import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import mindex from '@/components/pages/mindex'
import circle from '@/components/pages/circle'
import found from '@/components/pages/found'
import mine from '@/components/pages/mine'
import cartemplate from '@/components/pages/cartemplate'
import feedback from '@/components/pages/feedback'
import cartbox from '@/components/pages/cartbox'
import messagelist from '@/components/pages/messagelist'
import cartform from '@/components/pages/cartform'
import chat from '@/components/pages/chat'
import map from '@/components/pages/map'
import cartcode from '@/components/pages/cartcode'
import mycart from '@/components/pages/mycart'
import daily from '@/components/pages/daily'
import circlelist from '@/components/pages/circlelist'
import circlefollow from '@/components/pages/circlefollow'
import circlevisit from '@/components/pages/circlevisit'
import searchcircle from '@/components/pages/searchcircle'
import dynamic from '@/components/pages/dynamic'
import dynamicdetails from '@/components/pages/dynamicdetails'
import circlecontent from '@/components/pages/circlecontent'
import publish from '@/components/pages/publish'
import creatcircle from '@/components/pages/creatcircle'
import cropper from '@/components/pages/cropper'
import address from '@/components/pages/address'
import cover from '@/components/pages/cover'
import othercart from '@/components/pages/othercart'
import login from '@/components/pages/login'
import forward from '@/components/pages/forward'
import choosecircle from '@/components/pages/choosecircle'
import report from '@/components/pages/report'
import collection from '@/components/pages/collection'
import appshare from '@/components/pages/appshare'
import cartsearch from '@/components/pages/cartsearch'
import addperson from '@/components/pages/addperson'
import appdownload from '@/components/pages/appdownload'
import fansbox from '@/components/pages/fansbox'
import followbox from '@/components/pages/followbox'
import exchangecart from '@/components/pages/exchangecart'
import findperson from '@/components/pages/findperson'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      name:'cover',
      component:cover
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children:[
        {path:'/',name:'mindex',component:mindex,meta: {
          keepAlive: false, //该字段表示该页面需要缓存
          isBack: false //判断是否是返回       
        }},
        {path:'/circle',name:'circle',component:circle,redirect:'/circlelist',
          children:[
            {path:'/circlelist',name:'circlelist',
             meta: {
              keepAlive: false, //该字段表示该页面需要缓存
              isBack: false //判断是否是返回       
            },component:circlelist},
            {path:'/circlefollow',name:'circlefollow',
            meta: {
              keepAlive: true, //该字段表示该页面需要缓存
              isBack: false //判断是否是返回       
            },component:circlefollow},
            {path:'/circlevisit',name:'circlevisit',component:circlevisit,
            meta: {
          keepAlive: false, //该字段表示该页面需要缓存
          isBack: false //判断是否是返回       
        }
          }
          ]
      },     
        {path:'/found',name:'found',component:found, meta: {
          keepAlive: false, //该字段表示该页面需要缓存
          isBack: false //判断是否是返回       
        }},     
        {path:'/mine',name:'mine',component:mine,meta: {
          keepAlive: false, //该字段表示该页面需要缓存
          isBack: false //判断是否是返回       
        }},        
      ]
    },
    {
      path:'/cartemplate',
      name:'cartemplate',
      component:cartemplate,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/feedback',
      name:'feedback',
      component:feedback,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/cartbox',
      name:'cartbox',
      component:cartbox,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/messagelist',
      name:'messagelist',
      component:messagelist,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/cartform',
      name:'cartform',
      component:cartform,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/chat',
      name:'chat',
      component:chat,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      },
    },
    {
      path:'/map',
      name:'map',
      component:map,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/cartcode',
      name:'cartcode',
      component:cartcode,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/mycart',
      name:'mycart',
      component:mycart,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/daily',
      name:'daily',
      component:daily,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/searchcircle',
      name:'searchcircle',
      component:searchcircle,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/dynamic',
      name:'dynamic',
      meta: {
        keepAlive: true, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      },
      component:dynamic
    },
    {
      path:'/dynamicdetails',
      name:'dynamicdetails',
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      },     
      component:dynamicdetails
    },
    {
      path:'/circlecontent',
      name:'circlecontent',
      meta: {
        keepAlive: true, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      },
      component:circlecontent
    },
    {
      path:'/publish',
      name:'publish',
      component:publish,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },{
      path:'/creatcircle',
      name:'creatcircle',
      component:creatcircle,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/cropper',
      name:'cropper',
      component:cropper,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/address',
      name:'address',
      component:address,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/othercart',
      name:'othercart',
      component:othercart,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/login',
      name:'login',
      component:login,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/forward',
      name:'forward',
      component:forward,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/choosecircle',
      name:'choosecircle',
      component:choosecircle,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/report',
      name:'report',
      component:report,
      meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      }
    },
    {
      path:'/collection',
      name:'collection',
      meta: {
        keepAlive: true, //该字段表示该页面需要缓存
        isBack: false //判断是否是返回       
      },
      component:collection
    },
    {
      path:'/appshare',
      name:'appshare',
      component:appshare
    },
    {
      path:'/cartsearch',
      name:'cartsearch',
      component:cartsearch
    },
    {
      path:'/addperson',
      name:'addperson',
      component:addperson
    },
    {
      path:'/appdownload',
      name:'appdownload',
      component:appdownload
    },
    {
      path:'/fansbox',
      name:'fansbox',
      component:fansbox
    },
    {
      path:'/followbox',
      name:'followbox',
      component:followbox
    },
    {
      path:'/exchangecart',
      name:'exchangecart',
      component:exchangecart
    },
    {
      path:'/findperson',
      name:'findperson',
      component:findperson
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js